<div class="form-group ">
    <span class="icon {{icon}}"></span>
    <div class="inputs">
        <label *ngIf="label" [for]="labelFor">{{label}}</label>
        <ng-content></ng-content>
    </div>
</div>